import { BuildType } from 'src/enums/build/build-type';
import { Language } from 'src/enums/language';
import type { SharedContent } from 'src/models/cms/shared-content';

export const clubBannerIsActive = (sharedData: SharedContent) => sharedData.clubBanner?.showBanner;

export const clubNameDependingOnBuildTypeAndLanguage = (
  clubName: string | null | undefined,
  buildType: BuildType,
  language: Language
): string => {
  if (
    buildType === BuildType.DAVID_LLOYD_BELGIUM &&
    language === Language.NL_BE &&
    clubName?.toLowerCase()?.includes('antwerp')
  ) {
    return 'Antwerpen';
  }
  return clubName || '';
};
